import { useUnit } from 'effector-react'

import {
  $transactions,
  $totalCountOfTransactions,
  transactionsListMounted,
  getTransactions,
  $transactionsError,
} from './model'
import { TransactionRequest } from './types'

export const useTransactionsList = () => {
  const onChangeTransactionsList = ({
    clientId,
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: TransactionRequest) => {
    transactionsListMounted({
      clientId,
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  const loading = useUnit(getTransactions.pending)

  const transactions = useUnit($transactions)
  const transactionsError = useUnit($transactionsError)
  const totalCountOfTransactions = useUnit($totalCountOfTransactions)
  return {
    transactions,
    transactionsError,
    totalCountOfTransactions,
    loading,
    onChangeTransactionsList,
  }
}
